/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/SheetForecastFile', 'model/SheetForecastAggregatedBudgetReport', 'model/PerformanceIndicatorDataReport', 'model/SheetForecastFileReport'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('../model/SheetForecastFile'), require('../model/SheetForecastAggregatedBudgetReport'), require('../model/PerformanceIndicatorDataReport'), require('../model/SheetForecastFileReport'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.SheetForecastFileApi = factory(root.ForStractionServiceApi.ApiClient, root.ForStractionServiceApi.SheetForecastFile, root.ForStractionServiceApi.SheetForecastAggregatedBudgetReport, root.ForStractionServiceApi.PerformanceIndicatorDataReport, root.ForStractionServiceApi.SheetForecastFileReport);
  }
}(this, function(ApiClient, SheetForecastFile, SheetForecastAggregatedBudgetReport, PerformanceIndicatorDataReport, SheetForecastFileReport) {
  'use strict';

  /**
   * SheetForecastFile service.
   * @module api/SheetForecastFileApi
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new SheetForecastFileApi. 
   * @alias module:api/SheetForecastFileApi
   * @class
   * @param {module:ApiClient} apiClient Optional API client implementation to use,
   * default to {@link module:ApiClient#instance} if unspecified.
   */
  var exports = function(apiClient) {
    this.apiClient = apiClient || ApiClient.instance;


    /**
     * Callback function to receive the result of the sheetForecastFileAddPut operation.
     * @callback module:api/SheetForecastFileApi~sheetForecastFileAddPutCallback
     * @param {String} error Error message, if any.
     * @param {'Integer'} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * add
     * @param {String} _4SAPIAppID 
     * @param {module:model/SheetForecastFile} body 
     * @param {Object} opts Optional parameters
     * @param {Boolean} opts.useTemplateCompany  (default to false)
     * @param {Integer} opts.templateID 
     * @param {Boolean} opts.withNotification  (default to false)
     * @param {module:api/SheetForecastFileApi~sheetForecastFileAddPutCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link 'Integer'}
     */
    this.sheetForecastFileAddPut = function(_4SAPIAppID, body, opts, callback) {
      opts = opts || {};
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling sheetForecastFileAddPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling sheetForecastFileAddPut";
      }


      var pathParams = {
      };
      var queryParams = {
        'useTemplateCompany': opts['useTemplateCompany'],
        'templateID': opts['templateID'],
        'withNotification': opts['withNotification']
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = 'Integer';

      return this.apiClient.callApi(
        '/SheetForecastFile/add', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the sheetForecastFileAggregateDataGet operation.
     * @callback module:api/SheetForecastFileApi~sheetForecastFileAggregateDataGetCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/SheetForecastAggregatedBudgetReport>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * aggregateData
     * @param {String} _4SAPIAppID 
     * @param {Integer} forecastFileID 
     * @param {Boolean} preview 
     * @param {Object} opts Optional parameters
     * @param {Boolean} opts.sumPeriodValues  (default to false)
     * @param {module:api/SheetForecastFileApi~sheetForecastFileAggregateDataGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<module:model/SheetForecastAggregatedBudgetReport>}
     */
    this.sheetForecastFileAggregateDataGet = function(_4SAPIAppID, forecastFileID, preview, opts, callback) {
      opts = opts || {};
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling sheetForecastFileAggregateDataGet";
      }

      // verify the required parameter 'forecastFileID' is set
      if (forecastFileID == undefined || forecastFileID == null) {
        throw "Missing the required parameter 'forecastFileID' when calling sheetForecastFileAggregateDataGet";
      }

      // verify the required parameter 'preview' is set
      if (preview == undefined || preview == null) {
        throw "Missing the required parameter 'preview' when calling sheetForecastFileAggregateDataGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'forecastFileID': forecastFileID,
        'preview': preview,
        'sumPeriodValues': opts['sumPeriodValues']
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = [SheetForecastAggregatedBudgetReport];

      return this.apiClient.callApi(
        '/SheetForecastFile/aggregateData', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the sheetForecastFileDeleteGet operation.
     * @callback module:api/SheetForecastFileApi~sheetForecastFileDeleteGetCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * delete
     * @param {String} _4SAPIAppID 
     * @param {Integer} fileID 
     * @param {module:api/SheetForecastFileApi~sheetForecastFileDeleteGetCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.sheetForecastFileDeleteGet = function(_4SAPIAppID, fileID, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling sheetForecastFileDeleteGet";
      }

      // verify the required parameter 'fileID' is set
      if (fileID == undefined || fileID == null) {
        throw "Missing the required parameter 'fileID' when calling sheetForecastFileDeleteGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'fileID': fileID
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/SheetForecastFile/delete', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the sheetForecastFileEditPut operation.
     * @callback module:api/SheetForecastFileApi~sheetForecastFileEditPutCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * edit
     * @param {String} _4SAPIAppID 
     * @param {module:model/SheetForecastFile} body 
     * @param {Object} opts Optional parameters
     * @param {Boolean} opts.withNotification  (default to false)
     * @param {module:api/SheetForecastFileApi~sheetForecastFileEditPutCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.sheetForecastFileEditPut = function(_4SAPIAppID, body, opts, callback) {
      opts = opts || {};
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling sheetForecastFileEditPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling sheetForecastFileEditPut";
      }


      var pathParams = {
      };
      var queryParams = {
        'withNotification': opts['withNotification']
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/SheetForecastFile/edit', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the sheetForecastFileGenerateForecastSheetContentsGet operation.
     * @callback module:api/SheetForecastFileApi~sheetForecastFileGenerateForecastSheetContentsGetCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * generateForecastSheetContents
     * @param {String} _4SAPIAppID 
     * @param {Integer} forecastFileID 
     * @param {module:api/SheetForecastFileApi~sheetForecastFileGenerateForecastSheetContentsGetCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.sheetForecastFileGenerateForecastSheetContentsGet = function(_4SAPIAppID, forecastFileID, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling sheetForecastFileGenerateForecastSheetContentsGet";
      }

      // verify the required parameter 'forecastFileID' is set
      if (forecastFileID == undefined || forecastFileID == null) {
        throw "Missing the required parameter 'forecastFileID' when calling sheetForecastFileGenerateForecastSheetContentsGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'forecastFileID': forecastFileID
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/SheetForecastFile/generateForecastSheetContents', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the sheetForecastFileImportForecastDataGet operation.
     * @callback module:api/SheetForecastFileApi~sheetForecastFileImportForecastDataGetCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/PerformanceIndicatorDataReport>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * importForecastData
     * @param {String} _4SAPIAppID 
     * @param {Integer} forecastFileID 
     * @param {module:api/SheetForecastFileApi~sheetForecastFileImportForecastDataGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<module:model/PerformanceIndicatorDataReport>}
     */
    this.sheetForecastFileImportForecastDataGet = function(_4SAPIAppID, forecastFileID, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling sheetForecastFileImportForecastDataGet";
      }

      // verify the required parameter 'forecastFileID' is set
      if (forecastFileID == undefined || forecastFileID == null) {
        throw "Missing the required parameter 'forecastFileID' when calling sheetForecastFileImportForecastDataGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'forecastFileID': forecastFileID
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = [PerformanceIndicatorDataReport];

      return this.apiClient.callApi(
        '/SheetForecastFile/importForecastData', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the sheetForecastFileLoadGet operation.
     * @callback module:api/SheetForecastFileApi~sheetForecastFileLoadGetCallback
     * @param {String} error Error message, if any.
     * @param {module:model/SheetForecastFileReport} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * load
     * @param {String} _4SAPIAppID 
     * @param {Integer} entityID 
     * @param {module:api/SheetForecastFileApi~sheetForecastFileLoadGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/SheetForecastFileReport}
     */
    this.sheetForecastFileLoadGet = function(_4SAPIAppID, entityID, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling sheetForecastFileLoadGet";
      }

      // verify the required parameter 'entityID' is set
      if (entityID == undefined || entityID == null) {
        throw "Missing the required parameter 'entityID' when calling sheetForecastFileLoadGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'entityID': entityID
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = SheetForecastFileReport;

      return this.apiClient.callApi(
        '/SheetForecastFile/load', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the sheetForecastFileSendReminderGet operation.
     * @callback module:api/SheetForecastFileApi~sheetForecastFileSendReminderGetCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * sendReminder
     * @param {String} _4SAPIAppID 
     * @param {Integer} fileID 
     * @param {Integer} statusID 
     * @param {String} managerNote 
     * @param {module:api/SheetForecastFileApi~sheetForecastFileSendReminderGetCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.sheetForecastFileSendReminderGet = function(_4SAPIAppID, fileID, statusID, managerNote, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling sheetForecastFileSendReminderGet";
      }

      // verify the required parameter 'fileID' is set
      if (fileID == undefined || fileID == null) {
        throw "Missing the required parameter 'fileID' when calling sheetForecastFileSendReminderGet";
      }

      // verify the required parameter 'statusID' is set
      if (statusID == undefined || statusID == null) {
        throw "Missing the required parameter 'statusID' when calling sheetForecastFileSendReminderGet";
      }

      // verify the required parameter 'managerNote' is set
      if (managerNote == undefined || managerNote == null) {
        throw "Missing the required parameter 'managerNote' when calling sheetForecastFileSendReminderGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'fileID': fileID,
        'statusID': statusID,
        'managerNote': managerNote
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/SheetForecastFile/sendReminder', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the sheetForecastFileTouchGet operation.
     * @callback module:api/SheetForecastFileApi~sheetForecastFileTouchGetCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * touch
     * @param {String} _4SAPIAppID 
     * @param {Integer} fileID 
     * @param {Integer} statusID 
     * @param {String} responsibleUserNote 
     * @param {module:api/SheetForecastFileApi~sheetForecastFileTouchGetCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.sheetForecastFileTouchGet = function(_4SAPIAppID, fileID, statusID, responsibleUserNote, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling sheetForecastFileTouchGet";
      }

      // verify the required parameter 'fileID' is set
      if (fileID == undefined || fileID == null) {
        throw "Missing the required parameter 'fileID' when calling sheetForecastFileTouchGet";
      }

      // verify the required parameter 'statusID' is set
      if (statusID == undefined || statusID == null) {
        throw "Missing the required parameter 'statusID' when calling sheetForecastFileTouchGet";
      }

      // verify the required parameter 'responsibleUserNote' is set
      if (responsibleUserNote == undefined || responsibleUserNote == null) {
        throw "Missing the required parameter 'responsibleUserNote' when calling sheetForecastFileTouchGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'fileID': fileID,
        'statusID': statusID,
        'responsibleUserNote': responsibleUserNote
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/SheetForecastFile/touch', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
  };

  return exports;
}));
